import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flexDirection: 'row',
    display: 'flex',
    flex: 1,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  contactsContainer: {
    width: 400,
    display: 'flex',
    // flex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.only('md')]: {
      width: 300,
    },
  },
  conversationContainer: {
    display: 'flex',
    flex: 1,
    height: '100%',
    // backgroundColor: 'green',
  },
  profileContainer: {
    width: 400,
    height: '100%',
    backgroundColor: 'blue',
  },
}));
export default useStyles;
